import React, { useEffect, useRef } from "react";
import { Helmet } from 'react-helmet-async';
import LandingPageNavbar from "../components/LandingPageNavbar";
import Image1 from "../assets/images/shop/image-1.jpg";
import Image2 from "../assets/images/shop/image-2.png";
import Video1 from "../assets/images/shop/video-1.MP4";
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";

function Shop({ setPageTitle }) {
  const videoRef = useRef(null);
  useEffect(() => {
    setPageTitle("Shop - Bait Al Anaqah");
  }, [setPageTitle]);

  const handleMouseEnter = () => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  };

  const handleMouseLeave = () => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
  };

  return (
    <>
    <Helmet>
        <meta name="keywords" content="Bait Al Anaqah, Bespoke, Uniforms, Alteration, Custom, Dubai" />
        <meta name="title" property="og:title" content={setPageTitle}></meta>
        <meta property="og:type" content="website" />
        <meta name="description" property="og:description" content="Experience the elegance of Bait Al Anaqah, where every creation tells a story and reflects your unique identity while honoring your values." />
        <meta name="image" property="og:image" content={Image1} />
        <link rel="canonical" href="https://baitalanaqah.com/shop" />
      </Helmet>
      <LandingPageNavbar />
      <div className="vhx-100 overflow-hidden">
        <Container fluid className="px-0">
          <Row className="g-0">
            <Col lg={6} className="d-lg-block d-none position-relative overflow-hidden">
              <Link
                to="/executive-elegance"
                className="border-0"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <video
                  ref={videoRef}
                  src={Video1}
                  className="w-100 h-100 object-fit-cover"
                  muted
                  loop
                  playsInline
                  preload="auto"
                />
                <div
                  className="position-absolute bottom-50 start-50 translate-middle text-center text-light"
                  style={{ zIndex: 2 }}
                >
                  <h2 className="fw-light">Executive Elegance</h2>
                  <p className="text-small">Shop Now</p>
                </div>
              </Link>
            </Col>
            <Col lg={6} className="d-lg-none d-block vhx-30 position-relative overflow-hidden">
              <Link to="/executive-elegance" className="border-0">
                <img src={Image1} className="img-fluid img-fade-in" />
                <div className="position-absolute top-50 start-50 translate-middle text-center text-light">
                  <h2 className="fw-light">Executive Elegance</h2>
                  <p className="text-small">Shop Now</p>
                </div>
              </Link>
            </Col>
            <Col lg={6} className="position-relative overflow-hidden">
              <Link to="/arabian-ethereals" className="border-0">
                <img src={Image2} className="img-fluid img-fade-in img-fade-in" />
                <div className="position-absolute bottom-50 start-50 translate-middle text-center text-light">
                  <h2 className="fw-light">Arabian Ethereals</h2>
                  <p className="text-small">Shop Now</p>
                </div>
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Shop;
